import Link from "next/link";

import type { JSX } from "react";

/** Buscas populares exibidas no painel de busca (lista estática por enquanto). */
const POPULAR_SEARCHES = [
  "Camiseta oversized",
  "Camiseta básica",
  "Camiseta estonada",
  "Moletom canguru",
  "Moletom careca",
  "Baby look",
];

/** Conteúdo do painel de busca: chips de buscas populares. */
export const SearchFlyout = (): JSX.Element => {
  return (
    <div>
      <b className="mb-2 block text-xs uppercase tracking-wider text-brand-primary">Buscas populares</b>

      <div className="flex flex-wrap gap-1">
        {POPULAR_SEARCHES.map((term) => (
          <Link
            key={term}
            href={`/busca?search=${encodeURIComponent(term)}`}
            className="rounded-full border border-base-border px-2 py-[0.4rem] text-sm hover:bg-base-input-opacity-50"
          >
            {term}
          </Link>
        ))}
      </div>
    </div>
  );
};
